import Cookie from 'vue-cookies'
import { TOKEN_KEY } from '@/config/index'
export default {
  /**
   * 获取token
   */
  getToken() {
    return Cookie.get(TOKEN_KEY)
  },
  /**
   * 设置token
   * @param {String} token token内容
   */
  setToken(token) {
    Cookie.set(TOKEN_KEY, token)
  },
  /**
   * 清除token
   */
  removeToken() {
    Cookie.remove(TOKEN_KEY)
  },
  /**
   * 设置cookie
   * @param {String} name cookie名字
   * @param {String} value cookie内容
   */
  setCookie(name, value) {
    Cookie.set(name, value)
  },
  /**
   * 获取cookie
   * @param {String} name cookie名字
   */
  getCookie(name) {
    return Cookie.get(name)
  },
  /**
   * 清除cookie
   * @param {String} name
   */
  removeCookie(name) {
    Cookie.remove(name)
  },
}
